import React from "react";
import "./styles/Loggedin.scss";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {toggleShowUserNavigation} from "../navigation/NavigationActions";
import {AppState} from "../RootReducer";
import {AccountBalance, CurrencyDefinition, Settings} from "../http/protocol";
import CasinoCurrencySelector from "../casino/ui/CasinoCurrencySelector";
import {ContentModelName} from "../contenful/types";
import {fetchContent} from "../contenful/ContentfulActions";
import Menu from "../ui/navigation/Menu";
import {showCashier} from "../payments/DepositActions";
import {getUserCurrencies} from "../selectors/user-selectors";
import {getUnreadNotificationsCount} from "../selectors/messages-selector";
import {t} from "../i18n";
import {showMenuMobile} from "../user/UserActions";

interface Props {
    style?: object;
    username?: any;
    screenName?: any;
    balances?: AccountBalance[];
    currencies?: Array<CurrencyDefinition>;
    activeCurrency?: string;
    showBalance?: boolean;
    headerComponent?: boolean;
    settings?: Settings;
    showDepositModal? : () => void;
    unreadNotificationsCount?  : number;
    hideMenu ? : ()=>void;
    showMenu ? : ()=>void;
}


class MobileLoggedin extends React.Component<Props, { menuOpen? : boolean}>{
    constructor(props : Props) {
        super(props);
        this.state = { menuOpen : false };
    }
    close () {

        this.setState({ menuOpen : false });
        this.props.hideMenu && this.props.hideMenu();
    }
    open () {

        this.setState({ menuOpen : true });
        this.props.showMenu && this.props.showMenu();
    }
    render() {
        return(
            <div className={"loggedin"}>
                <div className={"loggedinContainer"}>
                    <CasinoCurrencySelector  />
                    <a ph-autocapture="true" ph-autocapture-event="deposit" className={"mobile-top-deposit"} onClick={() => this.props.showDepositModal && this.props.showDepositModal()}>
                        <i className={"material-icons"}>account_balance_wallet</i>
                        <span className="top-deposit-text mobile-logged-in">{t("transactions.types.deposit")}</span>
                    </a>
                    <div onClick={() => {
                      !this.state.menuOpen && this.open();
                    }} className={"mobile-account-button " + (this.state.menuOpen ? "active" : "")}>
                        <i className={"material-icons"}>account_circle</i>
                        {(this.props.unreadNotificationsCount ?? 0 ) > 0 && <span className={"unread-notifications floating"}>{this.props.unreadNotificationsCount}</span>}
                    </div>
                    <Menu open={this.state.menuOpen} close={()=> this.close()}/>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (app : AppState) => {
    return {
        username : app.user?.user?.username,
        screenName : app.user?.user?.attributes?.screenName,
        activeCurrency : app.user.activeCurrency,
        balances : app.user.balances,
        currencies: getUserCurrencies(app),
        showBalance: app.user.showBalance,
        settings : app.settings.settings,
        unreadNotificationsCount : getUnreadNotificationsCount(app)
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        toggleShowUserNavigation : (show: boolean)=>dispatch(toggleShowUserNavigation(show)),
        fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
        showDepositModal : () => dispatch(showCashier(true)),
        hideMenu : () => dispatch(showMenuMobile(false)),
        showMenu : () => dispatch(showMenuMobile(true))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(MobileLoggedin);